import React, { useState, useEffect, useRef } from 'react';
import {
    Box,
    Button,
    Card,
    CardContent,
    TextField,
    Typography,
    CircularProgress
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../services/axiosInstance';
import nwLogo from '../assets/images/Infinium.png';
//import nwLogo from '../assets/images/logo.png';
import splashImage from '../assets/images/infiniumsplash.png';
import appTitleImage from '../assets/images/qtitle.svg';

const LoginPage = ({ setAuthToken }) => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const isMounted = useRef(true);

    useEffect(() => {
        return () => {
            isMounted.current = false;
        };
    }, []);

    const handleLogin = async (event) => {
        event.preventDefault();
        setLoading(true);
        setError('');
        try {
            const response = await axiosInstance.post('/auth/login', { email, password });
            const { token, userId, client, role } = response.data;

                        // Block admin accounts from using normal login
            if (role === 'Admin') {
                navigate('/admin-login');
                return;
            }

            localStorage.setItem('token', token);
            localStorage.setItem('userId', userId);
            localStorage.setItem('client', client);
            localStorage.setItem('role', role);

            setAuthToken(token);

            if (role === 'Admin') {
                navigate(`/registeredUsers/${client}`);
            } else if (role === 'Unassigned') {
                navigate(`/select-certifications`);
            } else {
                navigate(`/${userId}`);
            }
        } catch (err) {
            if (isMounted.current) {
                if (err.response?.status === 429) {
                    setError('Too many login attempts. Please try again in 15 minutes.');
                } else {
                    setError('Invalid credentials');
                }
            }
        } finally {
            if (isMounted.current) {
                setLoading(false);
            }
        }
    };

    return (
    <Box position="relative" height="100vh" overflow="hidden">
    {/* Logo */}
    <Box sx={{ position: 'absolute', top: 15, left: 15, zIndex: 10 }}>
        <a href="https://infinium.consulting/" target="_blank" rel="noopener noreferrer">
            <img
                src={nwLogo}
                alt="Infinium Logo"
                style={{ height: '60px', objectFit: 'contain' }}
            />
        </a>
    </Box>

    {/* Full Background Image */}
    <Box
        sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
        }}
    >
        <img
            src={splashImage}
            alt="splash"
            style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                display: 'block'
            }}
        />
    </Box>

    {/* Login Form - Upper Left */}
    <Box
        sx={{
            position: 'absolute',
                // Desktop - top left
            top: { xs: '8%', md: '15%' },
            left: { xs: '4%', md: '8%' },
            // Full width on mobile, fixed width on desktop
            width: { xs: '92%', md: '400px' },
            zIndex: 5
        }}
    >
        <Card sx={{ p: { xs: 4, md: 4 }, borderRadius: 4, boxShadow: 8, maxHeight: { xs: '90vh', md: 'none' }, overflowY: { xs: 'auto', md: 'visible' }  }}>
            <CardContent>
                <Typography variant="h4" fontWeight="bold" gutterBottom>
                    Sign in
                </Typography>
                <Typography color="text.secondary" variant="body2" gutterBottom>
                    Please enter your credentials
                </Typography>
                <form onSubmit={handleLogin}>
                    <TextField
                        label="Email"
                        type="email"
                        fullWidth
                        margin="normal"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        autoComplete="email"
                        InputLabelProps={{ shrink: true }}
                    />
                    <TextField
                        label="Password"
                        type="password"
                        fullWidth
                        margin="normal"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        autoComplete="current-password"
                        InputLabelProps={{ shrink: true }}
                    />

                    {/* Forgot password link */}
                    <Typography
                        variant="body2"
                        color="primary"
                        sx={{ mt: 2, cursor: 'pointer' }}
                        onClick={() => navigate('/forgot-password')}
                    >
                        Forgot your password?
                    </Typography>

                    {/* Sign in button */}
                    <Button
                        type="submit"
                        variant="contained"  
                        color="primary"                      
                        fullWidth
                        sx={{mt: 2}}
                        disabled={loading}
                    >
                        {loading ? <CircularProgress size={24} color="inherit" /> : 'Sign in'}
                    </Button>

                    {error && (
                        <Typography color="error" variant="body2" mt={2}>
                            {error}
                        </Typography>
                    )}
                </form>
            </CardContent>
        </Card>
                    {/* App Title and Image */}
        <Box sx={{ mt: 3, textAlign: 'center', width: 380 }}>
            <img
                src={appTitleImage}
                alt="App Title"
                style={{ width: '100%', objectFit: 'contain' }}
            />
        </Box>
    </Box>
</Box>
    );
};

export default LoginPage;
